import Axios from 'axios'
import { getPathName, getApiHash, getApiToken } from './helper';

const obtenerPatente = async (patente, token) => {
    const params = {
        hash: await getApiHash(),
        patente: patente,
        captcha: token
    }
    const headers = { 
        'content-type': 'application/json',
        "Authorization" : 'Bearer ' + await getApiToken()
    }
    return await Axios.post(await getPathName() + "/getpatentejson", params,
        {
            headers: headers
        }).then(function (response) {
            if (response.data.patente.status === "OK") {
                return response.data.patente.datos;
            } else {
                return null;
            }
        }).catch(function (error) {
            return error;
    });
};

export default obtenerPatente;